import React from 'react';

const DataContextIcon = ({
  style = {},
  fill = '#3a84a8',
  width = '100%',
  className = '',
  height = '100%',
  viewBox = '0 0 951 1024',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M950.857 627.429q0 46.286-25.429 77.143t-70.571 30.857q-23.429 0-44.286-10t-33.714-21.714-32.286-21.714-40.571-10q-62.857 0-62.857 70.857 0 22.286 9.143 65.714t8.571 65.714v2.857q-12.571 0-18.857 0.571-19.429 1.714-55.714 6.571t-66 7.714-56 2.857q-34.857 0-58.857-15.143t-24-47.714q0-21.143 10-40.571t21.714-32.286 21.714-33.714 10-44.286q0-45.143-30.857-70.571t-77.143-25.429q-48 0-81.714 26t-33.714 72.857q0 24.571 8.571 47.429t19.143 36.857 19.143 30.286 8.571 28.857q0 25.714-26.286 50.857-21.143 20-66.857 20-54.286 0-140-13.714-5.143-1.143-15.714-2.286t-15.714-2.286l-7.429-1.143q-0.571 0-1.714-0.571-1.143 0-1.143-0.571v-585.143q1.143 0.571 10 2t19.429 2.857 12.286 2q85.714 13.714 140 13.714 45.714 0 66.857-20 26.286-25.143 26.286-50.857 0-12.571-8.571-28.857t-19.143-30.286-19.143-36.857-8.571-47.429q0-46.857 33.714-72.857t82.286-26q45.714 0 76.571 25.429t30.857 70.571q0 23.429-10 44.286t-21.714 33.714-21.714 32.286-10 40.571q0 32.571 24 47.714t58.857 15.143q36.571 0 102.857-8.571t93.143-9.714v1.143q-0.571 1.143-2 10t-2.857 19.429-2 12.286q-13.714 85.714-13.714 140 0 45.714 20 66.857 25.143 26.286 50.857 26.286 12.571 0 28.857-8.571t30.286-19.143 36.857-19.143 47.429-8.571q46.857 0 72.857 33.714t26 81.714z"
    />
  </svg>
);

export default DataContextIcon;
